// extracted by mini-css-extract-plugin
export var content = "member-dialog-module--content--b5f6e";
export var image = "member-dialog-module--image--f9a7d";
export var memberButton = "member-dialog-module--memberButton--c0b73 buttons-module--ctaButton--137bb";
export var subscribeContent = "member-dialog-module--subscribeContent--db212";